/* DON'T EDIT THIS FILE: edit original and run build again */ import React, { useContext } from "react";

export const PdfContext = React.createContext(false);

export const useIsInPdf = () => {
  const context = useContext(PdfContext);
  return !!context;
};
